var initial = {
    selectedApp: {}
}

const AdminReducer = (state = initial, action) => {
    switch(action.type){
        case "SELECTED_APPLICATION":
            state = {...state, selectedApp: action.payload}
            return state;
        case "CONFIRM_PAYMENT":
            console.log("Update")
            state = {...state, selectedApp: {...state.selectedApp, payment: {...state.selectedApp.payment, success: true} }}
            return state;
        case "VERIFIED":
            state = {...state, selectedApp: {...state.selectedApp, isVerified: true }}
            console.log("Update",state.selectedApp)
            return state;
        default:
            return state;
    }
}

export default AdminReducer;